const doc = [({"en":({"entryTitle":"Join Us on LINE!", "entryDescription":"Add a friend to get international travel consultation."})})];
module.exports = doc.length <= 1 ? doc[0] : doc;